<script>
	import { Username, FromPage, changePasswordThrough, IsMobileVerified, IsEmailValidated, PendingLoginPassword } from "./store.js";
	import { TitleList, User } from "../../store.js";
	import { onMount, createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();
    import Field from "../FormField.svelte";
    import AddressPicker from "../HTMLElements/AddressPicker.svelte";
    import TextBox from "../HTMLElements/Textbox.svelte";
    import Email from "../HTMLElements/Email.svelte";
    import Phone from "../HTMLElements/PhoneNumber.svelte";
    import SelectList from "../HTMLElements/Select.svelte";
    import CheckBox from "../HTMLElements/CheckBoxInput.svelte";
    import Modal from "../HTMLElements/Modal.svelte";
    import Help from "../help.svelte";
    import wrappedFetch from '../../wrappedFetch.js';
    import * as formValidator from "../Utils/ValidateFormFIelds.js";
    
    let error = '';
    let ref = null;
    let showHelpInfo = false;
	  let wrappedObj;
    let user = [];
    let privacyPolicyAccepted = false;
    let isMemberOfCrownService = false;
    let showCheckBoxModal = false;
    let showPrivacyModal = false;
    function toggleInfo() {
      showHelpInfo = !showHelpInfo;
    if(showHelpInfo)
      _paq.push(['trackEvent', 'Info', 'Recreate Account Details']); 
  }
    let username = $Username.value;
    let fromPage = $FromPage;
    
    let backURL;
    switch (fromPage) {
      case "registration": backURL = "/register/contactdetails"; break;
      case "password":     backURL = "/account/forgotpassword"; break;
      case "username":     backURL = "/account/forgotusername"; break;
      default:             backURL = "/signin";
    }

    let registerDetails = {
      title: { value: '', isDirty: false, isValid: false },
      firstName: { value: '', isDirty: false, isValid: false },
      lastName: { value: '', isDirty: false, isValid: false },
      address: { value: '', isDirty: false, isValid: false },
      postcode: { value: '', isDirty: false, isValid: false },
      email: { value: '', isDirty: false, isValid: true },
      Hometel: { value: '', isDirty: false, isValid: true },
      Worktel: { value: '', isDirty: false, isValid: true },
      Mobile: { value: '', isDirty: false, isValid: true },
    };

  let isFormValid = true;

  onMount(async () => {
    if (!$Username.value)
    {
      dispatch("pageChange", "/signin");
    }

    const res = await wrappedFetch("user/GetUserDetails?username=" + $Username.value);
    if (res.status === 403) {
      dispatch("pageChange", "/account/verifyidentity");
      return;
    }
    const result = await res.json();
    
    user = result;

    // Title always starts blank — user must actively select it during recreation.
    registerDetails.title     = { value: '',               isDirty: false, isValid: false };
    registerDetails.firstName = { value: user.firstname,   isDirty: false, isValid: !!user.firstname };
    registerDetails.lastName  = { value: user.lastname,    isDirty: false, isValid: !!user.lastname };
    registerDetails.address   = { value: user.address,     isDirty: false, isValid: !!user.address };
    registerDetails.postcode  = { value: user.postcode,    isDirty: false, isValid: !!user.postcode };
    registerDetails.email     = { value: user.email,       isDirty: false, isValid: !!user.email };
    registerDetails.Hometel   = { value: user.hometel || '', isDirty: false, isValid: true };
    registerDetails.Worktel   = { value: user.worktel || '', isDirty: false, isValid: true };
    registerDetails.Mobile    = { value: user.mobile,      isDirty: false, isValid: !!user.mobile };

    isMemberOfCrownService = !!user.isMemberOfCrownService;
  });

    const viewPrivacy = (e) => {
      e.preventDefault();
      showPrivacyModal = true;
    };

    const validate = async () => {
      isFormValid = true;

      if (!registerDetails.title.value) {
        registerDetails.title.isDirty = true;
        registerDetails.title.isValid = false;
      }

      const otherFieldsValid = formValidator.validate(registerDetails);
      const titleValid = registerDetails.title.isValid !== false;

      if (!otherFieldsValid || !titleValid || !privacyPolicyAccepted) {
        isFormValid = false;
        if (!privacyPolicyAccepted && otherFieldsValid && titleValid) {
          error = "You must agree to the privacy policy to continue.";
        } else {
          error = "Please ensure that you have completed the required fields.";
        }
        registerDetails = registerDetails;
        return;
      }

       const flattenedUser = Object.fromEntries(
          Object.entries(registerDetails).map(([key, field]) => [key, field.value])
        );

       var resp = await wrappedFetch("/user/ReinstateUserDetails", {
         method: "post",
         headers: {
           "Content-Type": "application/json",
         },
         body: JSON.stringify({
            user: flattenedUser,
            username: username,
            IsPrivacyPolicyAgreed: privacyPolicyAccepted ? 'Y' : 'N',
            isMemberOfCrownService: isMemberOfCrownService ? 'Y' : 'N',
            fromPage: fromPage }),
       });
       const data = await resp.json();
       console.log("data", data);
       if (data.success){
           $Username.value = $Username.value;
           // The email the reset actually goes to is the one SUBMITTED on
           // this form (the server stores and uses it) — not the stale USO
           // one, which for staff is an auto-provisioned @lgflmail address.
           $changePasswordThrough = registerDetails.email.value;

           // Login entry: the user already proved these credentials to get
           // here and no password reset was performed, so log them straight
           // in through the normal login endpoint (same credential check —
           // no bypass) rather than showing them their own username and
           // asking them to retype the password.
           if (fromPage === 'login' && $PendingLoginPassword) {
             const pwd = $PendingLoginPassword;
             $PendingLoginPassword = "";
             try {
               const loginResp = await wrappedFetch("user/login", {
                 method: "post",
                 headers: { "Content-Type": "application/json" },
                 body: JSON.stringify({ username: username, password: pwd, hash: "" }),
               });
               const loginData = await loginResp.json();
               if (loginData.success) {
                 $User = loginData.user;
                 dispatch("pageChange", "/user/home");
                 return;
               }
             } catch (e) {
               // fall through to the confirmation page below
             }
           }
           $PendingLoginPassword = "";
            dispatch("pageChange", "/account/accountrecreatedsuccess");
       }else{
         // Show the server's reason when it gives one (e.g. duplicate email) —
         // the generic line hid actionable messages.
         error = data.message || "There was an error recreating your account.";
       }
    }
  
</script>
<style>
h1 .info-help-container
 {
  border-left: 2px solid #6f4077;
  font-size: 14px;
  color: #6f4077;
  margin-bottom: .5rem !important;
  font-weight: initial;
}</style>

<form on:submit|preventDefault={validate} class="box" autocomplete="off">
  <div class="field">
    <a href="{backURL}">
      <span class="fas fa-arrow-left" />
      Back
    </a>
  </div>

  {#if fromPage === 'login'}
    <!-- Login entry: the user has just authenticated against USO. No
         password reset happens on this route — don't mention archives
         or new passwords (staff accounts arrive here too and were
         being told their brand-new account was 3 years inactive). -->
    <div class="notification">
      <p class="help" style="margin-bottom: 0px;"><strong>Finish setting up your account</strong><br><br>
        Please confirm your details below to continue. You will keep your existing username and password.</p>
    </div>
  {:else}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom: 0px;"><strong>We've Found an Inactive Account</strong><br><br>
        The details you entered match an account that has been inactive for over 3 years. As a result, the account has been archived in line with our data policy.<br><br>
        To reinstate your account, please confirm your details below. A new password will be sent to you via email.</p>
    </div>
  {/if}

  <h1 class="title is-4">Confirm Details</h1>

  <Field label="Title" role="dropdown" aria-label="Select your title" isRequired={true}>
    <span slot="inputField">
      <SelectList
        items={TitleList}
        label="your title"
        readoutLabel="title"
        selectedValueText="label"
        placeholder="Select your title"
        isRequired="true"
        bind:selectedValue={registerDetails.title.value}
        bind:isValid={registerDetails.title.isValid}
        bind:isDirty={registerDetails.title.isDirty} />
    </span>
  </Field>

  <Field label="First Name" hasIconLeft="true">
    <span slot="inputField">
      <TextBox
        bind:text={registerDetails.firstName.value}
        bind:isValid={registerDetails.firstName.isValid}
        bind:isDirty={registerDetails.firstName.isDirty}
        label="First Name"
        disabled={true} />
    </span>
  </Field>

  <Field label="Last Name" hasIconLeft="true">
    <span slot="inputField">
      <TextBox
        bind:text={registerDetails.lastName.value}
        bind:isValid={registerDetails.lastName.isValid}
        bind:isDirty={registerDetails.lastName.isDirty}
        label="last Name"
        disabled={true} />
    </span>
  </Field>

  <Field label="Email address" hasIconLeft="true">
    <span slot="inputField">
      <Email
        placeholder="email@domain.com"
        bind:email={registerDetails.email.value}
        bind:isValid={registerDetails.email.isValid}
        bind:isDirty={registerDetails.email.isDirty}
        label="email address"
        faIcon="fas fa-envelope"
        isRequired="true" />
    </span>
  </Field>

  <Field label="Home Postcode" hasIconLeft="true" />
  <AddressPicker
    bind:selectedAddress={registerDetails.address.value}
    bind:isValid={registerDetails.address.isValid}
    bind:isAddressDirty={registerDetails.address.isDirty}
    bind:postcode={registerDetails.postcode.value}
    bind:isPostcodeDirty={registerDetails.postcode.isDirty}
    bind:isPostcodeValid={registerDetails.postcode.isValid}
    ArchievedAddress={true}
    username="accountrecreation"
    isRequired={true} />

  <Field label="Mobile" hasIconLeft="true">
    <span slot="inputField">
      <Phone
        placeholder="07xxx xxxxxx"
        isRequired="true"
        bind:number={registerDetails.Mobile.value}
        bind:isValid={registerDetails.Mobile.isValid}
        bind:isDirty={registerDetails.Mobile.isDirty}
        isMobile="true"
        isWork="false"
        label="mobile phone number" />
    </span>
  </Field>

  <Field label="Landline" hasIconLeft="true" isRequired={false}>
    <span slot="inputField">
      <Phone
        placeholder="020 1234 5678"
        isRequired="false"
        bind:number={registerDetails.Hometel.value}
        bind:isValid={registerDetails.Hometel.isValid}
        bind:isDirty={registerDetails.Hometel.isDirty}
        isMobile="false"
        isWork="false"
        label="landline phone number" />
    </span>
  </Field>

  <Field label="Work Phone Number" hasIconLeft="true" isRequired={false}>
    <span slot="inputField">
      <Phone
        placeholder="020 1234 5678"
        isRequired="false"
        bind:number={registerDetails.Worktel.value}
        bind:isValid={registerDetails.Worktel.isValid}
        bind:isDirty={registerDetails.Worktel.isDirty}
        isMobile="false"
        isWork="true"
        label="work phone number" />
    </span>
  </Field>

  <CheckBox
    helpId="help36"
    label=" I am a Crown Servant"
    bind:checked={isMemberOfCrownService}
    bind:showModal={showCheckBoxModal}
    on:change={()=>{if (isMemberOfCrownService) showCheckBoxModal = true;}} />

  <hr />

  <div class="field">
    <label class="checkbox">
      <input type="checkbox" bind:checked={privacyPolicyAccepted} />
      <span>I agree to the</span>
      <a
        href="#"
        on:click={viewPrivacy}
        style="margin-left:4px; cursor: pointer;">
        privacy policy
      </a>
    </label>
  </div>

  {#if error!=''}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom:0px">{@html error}</p>
    </div>
  {/if}

  <div style="text-align: right;">
    <button type="submit" class="button is-purple">
      Continue
    </button>
  </div>
</form>

<Modal bind:showModal={showCheckBoxModal}>
  <Help
    helpId="Help36"
    showSearchOption={false}
    showContent={false}
    doAnimation={false} />
</Modal>

<Modal bind:showModal={showPrivacyModal}>
  <Help
    helpId="Help16"
    isPopup={true} 
    showContent={true} />
</Modal>